
import Vue from "vue";
import { ViewColumn } from "@/utils/views/view-column";
import { ModelNamedProperty } from "../../utils/models/named-property";
import AppImageClickActionOptionsEdit from "./ColumnEditImageClickActionOptionsEdit.vue";

export default Vue.extend({
	props: {
		value: {
			type: Object as ()=>ViewColumn,
			required: true
		},
		field: {
			type: Object as()=>ModelNamedProperty,
			required: true
		}
	},
	components: {
		AppImageClickActionOptionsEdit
	}
});
